import React,{useRef, useState, useEffect} from "react";
import {X, CircleNotch, Info} from "@phosphor-icons/react";
import layerEvents from "../utils/layerEvents";
import vindrApi from "../utils/vindrapi";
import { Col, Row, Modal, Button} from "react-bootstrap";
import EditableRange from "../components/EditableRange";

class OverlayNoise {

	max = 8;
	min = 6;
	layerId = 'noise-fill';
	sourceId = 'noise-source';

	noiseData = {
		method:null,
		updated:false
	};
	constructor() {
		
	}
	handleOpacityChange = (opc) => {
		this.opacity = opc;
		this.setLayerOpacity(this.layerId, opc);
	}

	addLayer(){
		

			if(!this.map.getSource(this.sourceId)){
				this.map.addSource(this.sourceId, {
					type: 'geojson',
					data: this.noiseData.isolines
				});

				//set the opacity if there is a preset
				this.map.addLayer({
					id: this.layerId,
					type: 'fill',
					source: this.sourceId,
					paint: OverlayNoise.layerPaint
				});


	//			setTimeout(()=>{
	//				this.gradient.current.style.background=this.activeLayer.gradient;
	//				this.parent.forceUpdate();
	//			},100);			
				//this.map.on('click', this.handleClick);
				//this.map.on('mousemove', this.setGetter);

				this.map.moveLayer(this.layerId);	

			}
		
	}
	remLayer(){
		
		if(!this.map.getSource(this.sourceId))
			return;
		

		if(this.map.getLayer(this.layerId))
			this.map.removeLayer(this.layerId);
		
		if(this.map.getSource(this.sourceId))
			this.map.removeSource(this.sourceId);
		
		
	}
	getNoiseLayer(){
		
		vindrApi.getNoiseLayer(this.context.tc.scenario.projectid, this.context.tc.scenario.scenario_id).then((result)=>{
			
			this.noiseData = result;
			this.noiseData.updated = true;
			this.parent.forceUpdate(); //will call this.panelk() on re-render
		});
		
	}
	convertPadding(value){
		
		var p = value-6;
		if(p<0)
			p=0;
		if(p>2)
			p=2;
		
		
		// 0->2 === 0->245px 
		p = (p*122.5);
		return p;
		
	}
	setLayerOpacity(l, opacity){
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = this.map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				this.map.setPaintProperty(l, 'icon-opacity', opc);
				this.map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				this.map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				const s = structuredClone(OverlayNoise.scale);
				const newScale = s.map((s)=>{s.opacity *= opacity; return s;});
				var op = OverlayNoise.paintOpacity(newScale);
				this.map.setPaintProperty(l, layer.type+'-opacity', op[layer.type+'-opacity']);
			}
		}
	}
	
	enterOverlay(){
		this.getNoiseLayer();
		this.context.tc.sensorModeForce();
	}
	exitOverlay(){
		this.remLayer();
		this.parent.forceUpdate();
		this.context.tc.landownerModeForce();
		
		

	}
	handleClose(){
		
		if(this.parent && this.parent.exitMode)
			this.parent.exitMode();
	}
	handleCalculate(){
		vindrApi.startNoiseLayer(this.context.tc.scenario.projectid, this.context.tc.scenario.scenario_id).then((result)=>{
			
			this.noiseData = result;
			this.context.QN.current.show("Noise calculation in progress. Reload page in a few minutes to see updated data.");
			this.noiseData.updated = true;
			this.parent.forceUpdate(); //will call this.panelk() on re-render
			
			this.handleClose();
		});
	}
	showCalculate(){
		
		
		
		return (
			<Modal className="modalNoise" show={true} onHide={(e)=>this.handleClose(e)}  centered>
				<Modal.Header closeButton>
					<Modal.Title>Calculate noise levels</Modal.Title>
				</Modal.Header>


						

				<Modal.Body>
					<Row className="mb-3">

						<Col xs="12" className="feedback-text mb-5">
							Noise levels are not calculated for this scenario yet. This prosess takes a few minutes.
						</Col>
					</Row>
				</Modal.Body>


				<Modal.Footer>
					<Button variant="outline-primary" onClick={(e)=>this.handleClose()}>Cancel</Button>
					<Button variant="primary" type="submit" onClick={(e)=>this.handleCalculate()}>Start calculation to continue</Button>
				</Modal.Footer>
						
					
			</Modal>
		)
	}
	showControl(){
		return (
			<div className="card overlayNoise">
				<div className="row title">
					Noise levels
					<span onClick={(e)=>{this.handleClose();}} className="btn btn-close alt btn-sm float-end"><X size={12} /></span>
				</div>
				{
				this.noiseData.state == 'waiting' &&
					<div className="my-3 mx-1">Status : Noise calculation in progress… This may take a few minutes</div>
				}
				{
				this.noiseData.state != 'waiting' &&
				<>
					<div className="my-3">
						Decibel scale (dB)
						
						<div className="branded-tooltip">
							<Info size={16} />
							<div className="text">
								<span><Info size={16} /> DECIBEL </span>

								Is a simplified noise calculation method in windPRO. It uses the ISO 9613-2 standard with basic sound propagation modelling. It provides conservative noise predictions for regulatory compliance and initial assessments. The calculation assumes the turbine is always operating and oriented directly downwind towards the receptor.
							</div>
						</div>
					</div>
					<div className="scale">
						<ul>
							{
								OverlayNoise.scale.map((a)=>{
									return (<li><span class="square" style={{backgroundColor:a.color, opacity:a.opacity}}></span> {a.label}</li>)
								})
							}
						</ul>


					</div>
					<Row>
						<Col xs="12 style-name pt-2">
							Layer opacity (%)
						</Col>
						<Col xs="12">
							<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={100} defaultValue={100} onChange={(e)=>{this.handleOpacityChange(e.target.value/100);}} />
						</Col>
					</Row>	
				</>
				}
			</div>
		)
	}
	panel(){
		if(!this.noiseData.updated)
			return;
		
		
		if(this.noiseData.state){
			this.addLayer();
			return this.showControl();
		}
		else
			return this.showCalculate();
		
		
	}
}

OverlayNoise.scale = [
	{
		color: "#265100",
		opacity: .25,
		label: "35 - 40 dB"
	},
	{
		color: "#265100",
		opacity: .5,
		label: "40 - 45 dB"
	},
	{
		color: "#265100",
		opacity: .75,
		label: "45 - 50 dB"
	}
]

OverlayNoise.paintOpacity = (scale)=>{ 
	return {
		'fill-opacity': ['case', 
			['<', ['get', 'decibel'], 40], scale[0].opacity, 
			['all', ['>=', ['get', 'decibel'], 40],['<', ['get', 'decibel'], 45]], scale[1].opacity,
			['>=', ['get', 'decibel'], 45], scale[2].opacity, 

			1
		]
	};
};


OverlayNoise.layerPaint = {
	...{
		'fill-color': ['case', 
			['<', ['get', 'decibel'], 40], OverlayNoise.scale[0].color, 
			['all', ['>=', ['get', 'decibel'], 40],['<', ['get', 'decibel'], 45]], OverlayNoise.scale[1].color,
			['>=', ['get', 'decibel'], 45], OverlayNoise.scale[2].color, 

			'#265100'
		]
	},
	...OverlayNoise.paintOpacity(OverlayNoise.scale)
};

export default OverlayNoise;